import styled from "styled-components";
import { theme } from "@themes";

export const Text = styled.div`
  .label1 {
    width: 238px;
    color: ${({ theme }) => theme.primary.purple};
    font-style: normal;
    line-height: 24px; /* 200% */
    letter-spacing: -0.132px;
    font-size: 12px;
    margin-top: 72px;
    font-weight: bold;
  }
  .label2 {
    color: ${({ theme }) => theme.neutral.gray[2600]};

    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 240% */
    letter-spacing: -0.11px;
  }
  .label3 {
    color: #494949;

    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 24px; /* 240% */
    letter-spacing: -0.11px;
  }
  .label4 {
    color: #494949;

    font-size: 10px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: -0.11px;
  }
`;
export const ButtonView = styled.div`
  display: flex;
  width: 124px;
  height: 26px;
  padding: 11px 32px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  background: ${({ theme }) => theme.button.primary};
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
  }
  .button {
    color: ${({ theme }) => theme.background.light};
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    white-space: nowrap;
  }
`;